export enum ThemeTypes {
    DARK = 'dark',
    LIGHT = 'light'
}
